import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import SiwzService from "services/SiwzService";
import Loading from "components/Loading";
import SwzGeneratorSection from "./SwzGeneratorSection";
import Form from "components/Form";
import useId from "hooks/useId";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ValidationShema from "constants/ValidationShema";
import PapersGeneratorService from "services/PapersGeneratorService";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import useSnackbar from "hooks/useSnackbar";

const useStyle = makeStyles(theme => ({
    wrap: {
        minWidth: 600,
        minHeight: 40
    }
}));


function ChooseSwzGeneratorOptions(
    {
        id,
        onClose,
        formSubmit,
        shareSystem
    }) {

    const classes = useStyle();
    const [sections, setSections] = useState(null);
    const [working, setWorking] = useState(true);
    const {enqueueSuccessSnackbar} = useSnackbar();

    useEffect(() => {
        PapersGeneratorService.getSwzGeneratorParams(id).then(resp => {
            setSections(resp);
            setWorking(false);
        });
    }, [id])

    const getInitialValues = (sections) => {
        const inits = {};
        sections.result.forEach(s => {
            s.questions.forEach(q => {
                q.type === 'select' ?
                    inits[q.key.replace(/\./g, '#')] = "" + !q.options[0].value
                    :
                    q.options.forEach(o => {
                        inits[o.key.replace(/\./g, '#')] = o.value;
                        if (o.subOptions) {
                            o.subOptions.forEach(so => {
                                inits[so.key.replace(/\./g, '#')] = so.value;
                            })
                        }
                    })
            })
        })
        return inits
    }
    const formId = useId();
    const onSubmit = (values) => {
        setWorking(true);
        const selected = [];
        for (const [key, value] of Object.entries(values)) {
            if (value === true || value === 'true') {
                selected.push(key.replace(/#/g, '.'))
            }
        }

        if (shareSystem) {
            SiwzService.shareGenerateSWZ(id, selected, shareSystem).then(resp => resp ? enqueueSuccessSnackbar(Tr("int_upload_success_x", {x: shareSystem}, true)) : null).finally(onClose);
        } else {
            SiwzService.generateSWZ(id, selected, onClose)
        }

    }


    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined'));
        buttons.push(createButton(Tr('swz.button.generate'), () => formSubmit[formId](), undefined, working));
        return <MultiButton buttons={buttons}/>;
    }
    return (
        <Dialog
            open
            title={Tr('swz.generator.popup.title')}
            titleCentered
            maxWidth="md"
            fullWidth={false}
            onClose={onClose}
            dialogActions={getActions()}
        >
            <div className={classes.wrap}>
                {
                    !sections ?
                        <Loading/> :
                        <>
                            <Form
                                initialValues={getInitialValues(sections)}
                                validationSchema={ValidationShema.any()}
                                onSubmit={onSubmit}
                                id={formId}
                            >
                                {(formikProps) => (
                                    sections.result.map(x => (
                                        <SwzGeneratorSection formikProps={formikProps} key={x.key} section={x}/>))
                                )}
                            </Form>

                        </>
                }
            </div>
        </Dialog>
    )
}

ChooseSwzGeneratorOptions.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(ChooseSwzGeneratorOptions);